import { Add, AddBox, ArrowBack, ArrowForward, Delete, Save } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import store from "./../Store/index";
import axios from "axios";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { SecurityChequeReducerAction } from "../Store/SecurityCheque/SecurityChequeReducer";
import NoDataFound from "../CustomComponents/NoDataFound";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useRef } from "react";

const SecurityChequeList = (props) => {
  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const chequeDetailData = useSelector(
    (state) => state.securityCheque.chequeDetailData
  );

  const chequeDetailsInfo = useSelector(
    (state) => state.securityCheque.chequeDetailsInfo
  );

  const filterValues = useSelector(
    (state) => state.securityCheque.filterValues
  );

  const datarows = useSelector((state) => state.securityCheque.chequeGridRows);

  const saveBtnDisable = useSelector(
    (state) => state.securityCheque.saveBtnDisable
  );

  const showChequeListGrid = useSelector(
    (state) => state.securityCheque.showChequeListGrid
  );

  const userName = useSelector((state) => state.branch.userName);

  const [deleteOperationActive, setDeleteOperationActive] =
    React.useState(false);

  // Dialog msg content.
  const [saveInfoDialogMessage, setSaveInfoDialogMessage] = useState("");
  const [saveInfoDialogTitleMessage, setSaveInfoDialogTitleMessage] =
    useState("");
  //Maintainig State for Dialog while submitting the application
  const [saveInfoDialogOpen, setSaveInfoDialogOpen] = useState(false);

  // Confirmation Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [open, setOpen] = useState(false);

  const [duplicateChequeResponseData, setDuplicateChequeResponseData] = useState();

  const columns = [
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "chequeNum",
      headerName: "Cheque Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      type: "string",
    },
    {
      field: "chequeDate",
      headerName: "Cheque Date",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "date",
      valueFormatter: (params) =>
        params?.value !== null &&
        params?.value !== undefined &&
        params?.value !== ""
          ? dayjs(params?.value).format("DD/MM/YYYY")
          : null,
    },
    {
      field: "repayAmt",
      headerName: "Repay Amount",
      headerAlign: "center",
      align: "right",
      flex: 190,
      renderCell: (params) => {
        return params.value === "0"
          ? 0
          : parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "chequeAmt",
      headerName: "Cheque Amount",
      headerAlign: "center",
      align: "right",
      flex: 190,
      type: "number",
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
    },
    {
      field: "chequeStatus",
      headerName: "Cheque Status",
      headerAlign: "center",
      align: "left",
      flex: 200,
      type: "singleSelect",
      valueOptions: ["ENTRY", "CANCEL"],
    },
    {
      field: "deleteBtn",
      headerName: "",
      headerAlign: "center",
      align: "center",
      flex: 100,
      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              disabled={props.screenMode === "VIEW"}
              fontSize="small"
              sx={{ color: "#004A92", fontWeight: 700 }}
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  const [gridColumns, setGridColumns] = React.useState(columns);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  //shortcut key
  const addRowRef = useRef(null);
  const addIconRef = useRef(null);
  const okRef = useRef(null);
  const cancelRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const saveIconRef = useRef(null);
  const dateRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.addEventListener("keydown", onKeyUnmountEventHandler);
      window.addEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "securityList",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "k") {
        okRef.current.click();
      } else if (charCode === "q") {
        cancelRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "s") {
        saveRef.current.click();
      } else if (charCode === "s") {
        saveIconRef.current.click();
      }
    }
  };

  useEffect(() => {
    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    let offset = (page - 1) * rowsPerPage;
    setRows([...datarows].slice(offset, offset + rowsPerPage));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toString().split(".")[0]) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);

    // for modify mode empty grid columns & rerender the same columns again.
    if (props.screenMode === "CREATE") {
      const newColumns = [...columns].filter(
        (col) => col.field !== "chequeDate" && col.field !== "chequeAmt"
      );
      setGridColumns([...newColumns]);
    }
    if (props.screenMode === "VIEW") {
      const newColumns = [...columns]
        .filter((col) => col.field !== "deleteBtn");
      setGridColumns([...newColumns]);
    }
    if (props.screenMode === "MODIFY") {
      let newcolumns = [];
        let filteredColumns = [...columns].filter(
          (col) =>
            col.field !== "chequeDate" &&
            col.field !== "repayAmt" &&
            col.field !== "chequeAmt" &&
            col.field !== "chequeStatus" &&
            col.field !== "deleteBtn"
        );
        newcolumns.push({
          field: "chequeDate",
          headerName: "Cheque Date",
          headerAlign: "center",
          align: "right",
          flex: 200,
          type: "date",
          editable: true,
          valueFormatter: (params) =>
            params?.value !== null &&
              params?.value !== undefined &&
              params?.value !== ""
              ? dayjs(params?.value).format("DD/MM/YYYY")
              : null,
        });
        newcolumns.push({
          field: "repayAmt",
          headerName: "Repay Amount",
          headerAlign: "center",
          align: "right",
          flex: 190,
          renderCell: (params) => {
            return params.value === "0"
              ? 0
              : parseInt(params.value).toLocaleString("en-IN");
          },
        });
        newcolumns.push({
          field: "chequeAmt",
          headerName: "Cheque Amount",
          headerAlign: "center",
          align: "right",
          flex: 190,
          editable: true,
          type: "number",
          renderCell: (params) => {
            let value =
              params.value === undefined ||
                params.value === null ||
                params.value === "" ||
                params.value === "0"
                ? 0
                : Number(params.value) <= 0
                  ? 0
                  : parseInt(params.value).toLocaleString("en-IN");
            return value;
          },
        });
        newcolumns.push({
          field: "chequeStatus",
          headerName: "Cheque Status",
          headerAlign: "center",
          align: "left",
          flex: 200,
          editable: true,
          type: "singleSelect",
          valueOptions: ["ENTRY", "CANCEL"],
        });
        newcolumns.push({
          field: "deleteBtn",
          headerName: "",
          headerAlign: "center",
          align: "center",
          flex: 100,
          renderCell: (params) => {
            return (
              <Tooltip title="Delete">
                <Delete
                  disabled={props.screenMode === "VIEW"}
                  fontSize="small"
                  sx={{ color: "#004A92", fontWeight: 700 }}
                  onClick={() => {
                    deleteSelectedRow(params);
                  }}
                ></Delete>
              </Tooltip>
            );
          },
        })
        filteredColumns = filteredColumns.concat(newcolumns);
        setGridColumns(filteredColumns);
    }
  }, [datarows, saveBtnDisable, props.screenMode]);

  useLayoutEffect(() => { }, [saveBtnDisable, props.screenMode]);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  //Delete Button Handler
  const deleteSelectedRow = (params) => {
    setDeleteOperationActive(true);
    const chequeDetailsDataInfo =
        store.getState().securityCheque.chequeDetailsInfo;
    setTimeout(() => {
      // get the latest records.
      let latestRecords = store.getState().securityCheque.chequeGridRows;
      const filteredRows = [...latestRecords].filter((data) => {
        return data.id !== params.id;
      });
      const noOfCheque = Number(chequeDetailsDataInfo.noOfCheque - 1)
      const startChequeNumber = Number(chequeDetailsDataInfo.startChequeNumber);

      const latestNoOfCheque = {
        noOfCheque: noOfCheque
      };
      if (filteredRows.length === Number(noOfCheque)) {
        let updatedRows = filteredRows.map((row, index) => {
          let recordData = { ...row };
          recordData.id = startChequeNumber + index;
          recordData.chequeNum = String(startChequeNumber + index);
          return recordData;
        })

        dispatch(
          SecurityChequeReducerAction.updateChequeListGridRows([...updatedRows])
        );
        dispatch(
          SecurityChequeReducerAction.updateChequeDetailsInfo({
            ...chequeDetailsDataInfo, ...latestNoOfCheque
          }
          )
        );
      }
      // comment the below spec for now ...
      // if (filteredRows.length !== Number(noOfCheque)) {
      //   // the remaining count of numbers to be added as empty rows.
      //   const count = Number(noOfCheque) - filteredRows.length;
      //   let newRows = [];
      //   const chequeNums = [...filteredRows].map((row) => row.chequeNum).sort();
      //   let lastChequeNum = chequeNums[chequeNums.length - 1];
      //   for (let index = 0; index < count; index++) {
      //     let newRecord = {};
      //     newRecord.id = (Number(lastChequeNum) + (index + 1))
      //       .toString()
      //       .padStart("6", "0");
      //     newRecord.chequeNum = (Number(lastChequeNum) + (index + 1))
      //       .toString()
      //       .padStart("6", "0");
      //     newRecord.applicationNum = filterValues.applicationNum;
      //     newRecord.chequeDate = null;
      //     newRecord.repayAmt = chequeDetailData.repayAmt;
      //     newRecord.chequeAmt = chequeDetailData.chequeAmt;
      //     newRecord.chequeStatus = props.screenMode === "MODIFY" ? "" : "ENTRY";
      //     newRows.push(newRecord);
      //   }
      //   const totalRows = [...filteredRows].concat([...newRows]);
      //   dispatch(
      //     SecurityChequeReducerAction.updateChequeListGridRows([...totalRows])
      //   );
      //   if (deviceMode === "MOBILE") {
      //     let offset = (page - 1) * rowsPerPage;
      //     setPage(page);
      //     setRows([...totalRows].slice(offset, offset + rowsPerPage));
      //   }
      // }
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }, 500);
  };

  const onSaveButtonClickHandler = async () => {
    try {
      // get the latest records for save.
      const latestRecords = store.getState().securityCheque.chequeGridRows;
      // check for if any of the rows cheque num empty  before save.
      const invalidChequeNums = [...latestRecords].filter(
        (row) =>
          row.chequeNum === "" ||
          row.chequeNum === null ||
          row.chequeNum === undefined ||
          String(row.chequeNum).length !== 6
      );

      if (invalidChequeNums.length > 0) {
        setMessage("Some rows have Invalid Cheque Number.");
        setAlertType("error");
        openAlertHandler();
        return;
      }

      if (props.screenMode === "MODIFY") {
        // check for if any of the rows cheque date empty  before save.
        // const invalidChequeDates = [...latestRecords].filter(
        //   (row) =>
        //     row.chequeDate === "" ||
        //     row.chequeDate === null ||
        //     row.chequeDate === undefined ||
        //     new Date(row.chequeDate).toDateString() === "Invalid Date"
        // );

        // if (invalidChequeDates.length > 0) {
        //   setMessage("Some rows have Invalid Cheque Date.");
        //   setAlertType("error");
        //   openAlertHandler();
        //   return;
        // }

        const outOfRangeDates = [...latestRecords].filter((row) => {
          const value =
            new Date(row.chequeDate) < new Date("01/01/1970") ||
            new Date(row.chequeDate) > new Date("12/31/2055");
          return value;
        });

        if (outOfRangeDates.length > 0) {
          setMessage(
            "Some rows have Invalid Cheque Date as either less than 1970 or greater than 2055."
          );
          setAlertType("error");
          openAlertHandler();
          return;
        }
      }

      // empty Amount.
      const zeroRepayAmtRows = [...latestRecords].filter(
        (row) => Number(row.repayAmt) === 0
      );

      if (zeroRepayAmtRows.length > 0) {
        setMessage("Some rows have Zero Repay Amount Values.");
        setAlertType("error");
        openAlertHandler();
        return;
      }

      if (props.screenMode === "MODIFY") {
        const zeroChequeAmtRows = [...latestRecords].filter(
          (row) => Number(row.chequeAmt) === 0
        );
        if (zeroChequeAmtRows.length > 0) {
          setMessage("Some rows have Zero Cheque Amount Values.");
          setAlertType("error");
          openAlertHandler();
          return;
        }
      }

      // check for if any of the rows cheque Status empty before save.
      const invalidChequeStatus = [...latestRecords].filter(
        (row) =>
          row.chequeStatus === "" ||
          row.chequeStatus === null ||
          row.chequeStatus === undefined
      );

      if (invalidChequeStatus.length > 0) {
        setMessage("Some rows have Invalid Cheque Status.");
        setAlertType("error");
        openAlertHandler();
        return;
      }

      // check for no of rows should be equal to no of cheques entered.
      const chequeDetailDataInfo =
        store.getState().securityCheque.chequeDetailsInfo;
      if (latestRecords.length !== Number(chequeDetailDataInfo.noOfCheque)) {
        setMessage(
          "Number of rows not equal to the Number of Cheques Entered."
        );
        setAlertType("error");
        openAlertHandler();
        return;
      }

      const getSelectedBranchCode = (branchValue) => {
        const branchWithCodes = GetBranchDetailsWithCode();
        const branchCodeValue = branchWithCodes.find((branch) => {
          return branch.label === branchValue;
        });
        return branchCodeValue.code;
      };

      // validate the cheque number from the backend.
      const validateChequeNums = async () => {
        // get the chequeNums.
        const chequeNums = latestRecords.map((record) => record.chequeNum);
        try {
          // get the application num from the grid.
          const duplicateChequeResponse = await axios.post(
            "/securityCheque/duplicateChequeNumberCheck",
            {
              applicationNum: filterValues.applicationNum,
              chequeNumList: chequeNums,
            }
          );
          setDuplicateChequeResponseData(duplicateChequeResponse)
          if (
            props.screenMode === "CREATE" &&
            duplicateChequeResponse.data.status === "PARTIAL_CONTENT"
          ) {
            let errorChequeNums = [];
            errorChequeNums = errorChequeNums.concat([
              ...new Set(duplicateChequeResponse.data.receiptChequeNums),
            ]);
            errorChequeNums = errorChequeNums.concat([
              ...new Set(duplicateChequeResponse.data.securityChequeNums),
            ]);
            errorChequeNums = [...new Set(errorChequeNums.sort())];
            setMessage(
              duplicateChequeResponse.data.errorMesage +
                " :  " +
                errorChequeNums
            );
            setAlertType("error");
            openAlertHandler();
            return;
          } else if(props.screenMode === "CREATE" &&
              duplicateChequeResponse.data.status === "CANCELLED-DUPLICATE"){
            setOpen(true)
            setDialogTitleMessage("Confirmation");
            setDialogMessage(duplicateChequeResponse.data.errorMesage)
          } else {
            // means no duplicate exists.
            const recordsData = latestRecords.map((row) => {
              let recordValue = { ...row };
              recordValue.createdBy = userName;
              recordValue.lastModifiedBy = userName;
              recordValue.screenMode = props.screenMode;
              return recordValue;
            });
            // regenerate to single Vo Object for save.
            dispatch(SecurityChequeReducerAction.updateSaveBtnDisable(true));
            let filterValuesData = store.getState().securityCheque.filterValues;
            let chequeDetailDataValue =
              store.getState().securityCheque.chequeDetailsInfo;
            let recordData = {
              ...filterValuesData,
              ...chequeDetailDataValue,
            };
            recordData.securityChequeDtl = [...recordsData];
            recordData.createdBy = userName;
            recordData.lastModifiedBy = userName;
            recordData.screenMode = props.screenMode;
            const branchCodeValue = getSelectedBranchCode(recordData.branch);
            recordData.branchCode = branchCodeValue;
            let url = "/securityCheque/insertSecurityChequeData";
            if (props.screenMode === "CREATE") {
              url = "/securityCheque/insertSecurityChequeData";
            } else if (props.screenMode === "MODIFY") {
              url = "/securityCheque/updateSecurityChequeData";
            }
            const response = await axios.post(url, recordData);
            if (response.status === 200) {
              setMessage(
                props.screenMode === "CREATE"
                  ? "Security PDC Saved Successfully."
                  : "Security PDC updated Successfully."
              );
              setAlertType("success");
              openAlertHandler();
              setSaveInfoDialogTitleMessage("Information");
              if (props.screenMode === "CREATE") {
                setSaveInfoDialogMessage(
                  `Security PDC Created Successfully. Block Number : ` +
                    response.data.blockNumber
                );
                handleClickOpen();
              } else if (props.screenMode === "MODIFY") {
                setSaveInfoDialogMessage(`Security PDC Updated Successfully.`);
                handleClickOpen();
              }
            }
          }
        } catch (error) {
          console.log(error);
          return;
        }
      };
      validateChequeNums();
    } catch (error) {
      dispatch(SecurityChequeReducerAction.updateSaveBtnDisable(false));
      setMessage("Security PDC Save Failed.");
      setAlertType("error");
      openAlertHandler();
      console.log(error);
    }
  };

  const saveAfterDuplicateAccept = async() =>{
    // get the latest records for save.
    const latestRecords = store.getState().securityCheque.chequeGridRows;

    const getSelectedBranchCode = (branchValue) => {
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === branchValue;
      });
      return branchCodeValue.code;
    };

    // means no duplicate exists.
    const recordsData = latestRecords.map((row) => {
      let recordValue = { ...row };
      recordValue.createdBy = userName;
      recordValue.lastModifiedBy = userName;
      recordValue.screenMode = props.screenMode;
      return recordValue;
    });
    // regenerate to single Vo Object for save.
    dispatch(SecurityChequeReducerAction.updateSaveBtnDisable(true));
    let filterValuesData = store.getState().securityCheque.filterValues;
    let chequeDetailDataValue =
      store.getState().securityCheque.chequeDetailsInfo;
    let recordData = {
      ...filterValuesData,
      ...chequeDetailDataValue,
    };
    recordData.securityChequeDtl = [...recordsData];
    if(props.screenMode === "CREATE"){
      recordData.customerId = (recordData.capacityArray.indexOf(recordData.capacity) === 1) ? Number(chequeDetailDataValue.coapplicantId) : Number(recordData.customerId);
    }else if(props.screenMode === "MODIFY"){
      recordData.customerId = Number(chequeDetailDataValue.customerId);
    }
    recordData.createdBy = userName;
    recordData.lastModifiedBy = userName;
    recordData.screenMode = props.screenMode;
    const branchCodeValue = getSelectedBranchCode(recordData.branch);
    recordData.branchCode = branchCodeValue;
    let url = "/securityCheque/insertSecurityChequeData";
    if (props.screenMode === "CREATE") {
      url = "/securityCheque/insertSecurityChequeData";
    } else if (props.screenMode === "MODIFY") {
      url = "/securityCheque/updateSecurityChequeData";
    }
    try{
      const response = await axios.post(url, recordData);
      if (response.status === 200) {
        setMessage(
          props.screenMode === "CREATE"
            ? "Security PDC Saved Successfully."
            : "Security PDC updated Successfully."
        );
        setAlertType("success");
        openAlertHandler();
        setSaveInfoDialogTitleMessage("Information");
        if (props.screenMode === "CREATE") {
          setSaveInfoDialogMessage(
            `Security PDC Created Successfully. Block Number : ` +
              response.data.blockNumber
          );
          handleClickOpen();
        } else if (props.screenMode === "MODIFY") {
          setSaveInfoDialogMessage(`Security PDC Updated Successfully.`);
          handleClickOpen();
        }
      }
    }catch(error){
      console.log("error")
      return
    }
  }

  //Dialog 
  const handleConfirmClose = () => {
    let errorChequeNums = [];
    errorChequeNums = errorChequeNums.concat([
      ...new Set(duplicateChequeResponseData.data.receiptChequeNums),
    ]);
    errorChequeNums = errorChequeNums.concat([
      ...new Set(duplicateChequeResponseData.data.securityChequeNums),
    ]);
    errorChequeNums = [...new Set(errorChequeNums.sort())];
    setMessage(
        "Cheque Numbers are already present :  " +
        errorChequeNums
    );
    setAlertType("error");
    openAlertHandler();
    setOpen(false);
  };

  const handleOk = () => {
    setMessage("");
    saveAfterDuplicateAccept();
    setOpen(false);
  };

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
  };

  //Handling Dialog method
  const handleClickOpen = () => {
    setSaveInfoDialogOpen(true);
  };

  const handleClose = () => {
    setSaveInfoDialogOpen(false);
    setTimeout(() => {
      dispatch(SecurityChequeReducerAction.resetFilterValues());
      dispatch(SecurityChequeReducerAction.resetChequeDetailValues());
      dispatch(SecurityChequeReducerAction.resetChequeDetailsInfo());
      dispatch(SecurityChequeReducerAction.resetFileDetailsData());
      dispatch(SecurityChequeReducerAction.resetChequeListGridRows([]));
      dispatch(SecurityChequeReducerAction.resetAllTouchHandlers());
      dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(false));
      dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(false));
      dispatch(SecurityChequeReducerAction.updateSaveBtnDisable(false));
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
      props.onClearBtnClickHandler();
    }, 500);
  };

  const handleOnCellKeyDown = (params, event) => {
    if (params.field === "chequeAmt") {
      setDeleteOperationActive(true);
      const rowDataIndex = [...datarows].findIndex((data) => {
        return data.id === params.id;
      });

      let activeRecord = datarows[rowDataIndex];
      const updatedRecord = {
        ...activeRecord,
        chequeAmt:
          event.target.value <= 0 || Number(event.target.value) > 99999999
            ? 0
            : Math.floor(event.target.value),
      };
      let newItems = [...datarows];
      newItems[rowDataIndex] = updatedRecord;
      dispatch(
        SecurityChequeReducerAction.updateChequeListGridRows([...newItems])
      );
      if (Number(event.target.value) > 99999999) {
        setMessage("Cheque Amount can't be greater than 9,99,99,999.");
        setAlertType("error");
        openAlertHandler();
      } else if (String(event.target.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Cheque Amount.");
        setAlertType("error");
        openAlertHandler();
      }
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }
  };

  //Cell Change Handler
  const cellChangeHandler = (params) => {
    setDeleteOperationActive(true);
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    let updatedRecords = [];

    // initially check for duplicate Cheque Nums when rows greater than 1.
    let duplicateRecords = [];
    if (params.field === "chequeNum") {
      duplicateRecords = [...datarows].filter(
        (row) => row.chequeNum === String(params.value)
      );
      if (duplicateRecords.length > 0) {
        // means when edited cheque num column, if entered cheque num value from params.value
        // already exist on another record gives 1 record.
        // in case of duplicates don't update records since id of grid record also the cheque num.
        updatedRecords = [...datarows];
        setMessage("Duplicate Cheque Numbers can't be added.");
        setAlertType("error");
        openAlertHandler();
      } else if (!/^\d+$/.test(params.value)) {
        // when invalid cheque num exists.
        updatedRecords = [...datarows];
        setMessage("Invalid Cheque Number can't be added.");
        setAlertType("error");
        openAlertHandler();
      } else {
        updatedRecords = [...datarows].map((row) => {
          if (row.id === activeRecord.id) {
            let recordValue = { ...row };
            recordValue.id = params.value;
            recordValue.chequeNum = params.value;
            return recordValue;
          } else {
            return row;
          }
        });
      }
    }

    if (params.field === "chequeDate") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequeDate = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "repayAmt") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.repayAmt = Math.floor(
            Number(params.value) <= 0 ? 0 : params.value
          );
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "chequeAmt") {
      let invalidAmtExist = false;
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequeAmt = Math.floor(
            Number(params.value) <= 0 || Number(params.value) > 99999999
              ? 0
              : params.value
          );
          if (Number(params.value) > 99999999) {
            invalidAmtExist = true;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (invalidAmtExist) {
        setMessage(
          "Cheque Amount can't be greater than 9,99,99,999  so reset to default value Zero."
        );
        setAlertType("error");
        openAlertHandler();
      } else if (String(params.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Cheque Amount.");
        setAlertType("error");
        openAlertHandler();
      }
    }

    if (params.field === "chequeStatus") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequeStatus = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    dispatch(
      SecurityChequeReducerAction.updateChequeListGridRows([...updatedRecords])
    );
    setTimeout(() => {
      setDeleteOperationActive(false);
    }, 1000);
  };

  const gridRowAddButtonHandler = () => {
    setDeleteOperationActive(true);
    setTimeout(() => {
      let latestRecords = [
        ...store.getState().securityCheque.chequeGridRows,
      ];

      let newrecord = {};
      newrecord.chequeNum = String(latestRecords.map((record) => Number(record.id)).pop() + 1);
      newrecord.applicationNum = filterValues.applicationNum;
      newrecord.securityChequeHeaderKey = chequeDetailsInfo.securityChequeHeaderKey;
      newrecord.chequeDate = null;
      newrecord.chequeAmt = 0;
      newrecord.chequeStatus = props.screenMode === "MODIFY" ? "ENTRY" : "";
      newrecord.collectionCharge = chequeDetailsInfo.collectionCharge;
      newrecord.createdBy = userName;
      newrecord.createdDate = new Date().getTime();
      newrecord.id = String(latestRecords.map((record) => Number(record.id)).pop() + 1);
      newrecord.lastModifiedBy = userName;
      newrecord.lastModifiedDate = new Date().getTime();
      newrecord.repayAmt = chequeDetailsInfo.repayAmt;
      latestRecords.push(newrecord);
      
      dispatch(
        SecurityChequeReducerAction.updateChequeListGridRows([...latestRecords])
      );
      const latestNoOfCheque = {
        noOfCheque: chequeDetailsInfo.noOfCheque + 1
      };
      dispatch(
        SecurityChequeReducerAction.updateChequeDetailsInfo({
          ...chequeDetailsInfo, ...latestNoOfCheque
        }
        )
      );
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }, 1000);
  };

  return (
    <React.Fragment>
      <AccordianContainer
        id="accord"
        title="Security PDC Collection"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        {props.screenMode !== "VIEW" && !deviceModeValue && (
          <Box sx={{ float: "right" }}>
            <Tooltip title="Ctrl+S" placement="top">
              <Button
                sx={{ margin: "8px" }}
                variant="contained"
                size="small"
                disabled={
                  saveBtnDisable ||
                  datarows.length === 0 ||
                  deleteOperationActive
                }
                onClick={() => {
                  setTimeout(() => {
                    onSaveButtonClickHandler();
                  }, 1000);
                }}
                ref={saveRef}
              >
                SAVE
              </Button>
            </Tooltip>
            {props.screenMode === "MODIFY" && (
              <Tooltip title="Add(Ctrl+A)" placement="top">
                <Button
                  size="small"
                  variant="contained"
                  disabled={
                    saveBtnDisable ||
                    deleteOperationActive
                  }
                  onClick={() => {
                    gridRowAddButtonHandler();
                  }}
                  ref={addRowRef}
                >
                  <Add fontSize="small" />
                </Button>
              </Tooltip>)
            }
          </Box>
        )}

        <React.Fragment>
          {useMediaQuery("(min-width:1200px)") && (
            <CustomDataGrid
              noDataMessage="No Data."
              noDataOnFilterMessage="No Data on Applied Filter."
              rows={datarows}
              gridHeight={330}
              columns={gridColumns}
              loading={deleteOperationActive}
              rowHeight={40}
              pageSize={10}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              rowDoubleClickHandler={() => {}}
              onSortModelChange={() => {}}
              isCellEditable={() => true}
              onCellEditCommit={(params) => {
                cellChangeHandler(params);
              }}
              onCellKeyDown={(params, event) => {
                if (params.field === "chequeAmt") {
                  (event.key === "e" ||
                    event.key === "E" ||
                    event.key === "." ||
                    event.key.includes("-")) &&
                    event.preventDefault();
                  handleOnCellKeyDown(params, event);
                }
              }}
            />
          )}
          {useMediaQuery("(max-width:1200px)") && (
            <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
              <React.Fragment>
                <Grid
                  container
                  item
                  direction="row"
                  alignItems="flex-end"
                  justifyContent="flex-end"
                  sx={{ height: "60px", bgcolor: "white" }}
                >
                  {totalRowsCount > 10 && (
                    <Typography
                      sx={{
                        mr: 2,
                        color: "#004A92",
                        fontWeight: 700,
                      }}
                    >
                      {"Page Max Records : " + rowsPerPage}
                    </Typography>
                  )}
                  <Typography
                    padding="1px"
                    sx={{
                      color: "#004A92",
                      fontWeight: 700,
                    }}
                  >
                    {"Total Records : " + totalRowsCount}
                  </Typography>
                  <Pagination
                    count={totalPageCount}
                    color="primary"
                    onChange={handlePageChange}
                    page={page}
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: ArrowBack, next: ArrowForward }}
                        {...item}
                      />
                    )}
                  />
                  {props.screenMode !== "VIEW" && (
                    <Box sx={{ float: "right" }}>
                      <Tooltip title="Save(Ctrl+S)" placement="top">
                        <IconButton size="small">
                          <Save
                            fontSize="large"
                            onMouseOver={({ target }) => {
                              target.style.backgroundColor = "#004a92";
                              target.style.color = "white";
                            }}
                            sx={{
                              margin: "8px",
                              color: "#004A92",
                              fontWeight: 700,
                            }}
                            disabled={saveBtnDisable || datarows.length === 0}
                            onClick={() => {
                              setTimeout(() => {
                                onSaveButtonClickHandler();
                              }, 1000);
                            }}
                            ref={saveIconRef}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Add(Ctrl+A)" placement="top">
                        <IconButton size="small">
                          <AddBox
                            fontSize="large"
                            sx={{
                              color: "#004A92",
                              fontWeight: 700,
                            }}
                            disabled={saveBtnDisable}
                            onClick={() => {
                              setTimeout(() => {
                                gridRowAddButtonHandler();
                              }, 1000);
                            }}
                            ref={addIconRef}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
                <Grid container>
                  <Box
                    sx={{
                      height: accordianOpen
                        ? window.innerHeight - 540
                        : window.innerHeight - 250,
                      overflow: "auto",
                      flex: "1 auto",
                      marginBottom: "16px",
                    }}
                  >
                    {rows.map((row, index) => (
                      <React.Fragment>
                        <Grid
                          container
                          direction="column"
                          sx={{ flex: "1 auto" }}
                        >
                          <Card>
                            <CardHeader
                              subheader={"Cheque Number : " + row.chequeNum}
                              subheaderTypographyProps={{
                                color: "#004A92",
                                fontWeight: "700",
                              }}
                              action={
                                <React.Fragment>
                                  {props.screenMode !== "VIEW" && (
                                    <IconButton size="small">
                                      <Delete
                                        fontSize="small"
                                        sx={{
                                          color: "#004A92",
                                          fontWeight: 700,
                                        }}
                                        onClick={() => {
                                          let params = {
                                            id: row.id,
                                          };
                                          deleteSelectedRow(params);
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </React.Fragment>
                              }
                              sx={{
                                textAlign: "left",
                                padding: "16px 16px 0px 16px !important",
                              }}
                            />
                            <CardContent sx={{}}>
                              <Grid
                                container
                                item
                                direction="column"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                sx={{}}
                              >
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  justifyContent="flex-start"
                                >
                                  {props.screenMode !== "VIEW" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Number"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        <TextField
                                          autoComplete="off"
                                          sx={{
                                            "& .MuiInputBase-input": {
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            },
                                          }}
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            style: {
                                              textAlign: `left`,
                                              fontSize: "12px",
                                            },
                                          }}
                                          type="number"
                                          variant="standard"
                                          value={row.chequeNum}
                                          placeholder="Please Cheque Number"
                                          disabled={false}
                                          onChange={(event) => {
                                            if (
                                              event.target.value.length <= 6
                                            ) {
                                              let params = {
                                                id: row.id,
                                                field: "chequeNum",
                                                value: event.target.value,
                                              };
                                              cellChangeHandler(params);
                                            } else {
                                              return;
                                            }
                                          }}
                                          onBlur={() => {}}
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === "e" ||
                                              e.key === "E" ||
                                              e.key === "-" ||
                                              e.key === "+"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  {props.screenMode !== "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Date"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` :  ${
                                          row.chequeDate !== null &&
                                          row.chequeDate !== undefined &&
                                          row.chequeDate !== ""
                                            ? row.chequeDate
                                            : "------------------------"
                                        }`}
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  {props.screenMode === "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Date"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        <CustomDateField
                                          variant="standard"
                                          fullWidth={true}
                                          placeholder={
                                            "Please Select Cheque Date"
                                          }
                                          ref={dateRef}
                                          value={row.chequeDate}
                                          onChange={(value) => {
                                            let params = {
                                              id: row.id,
                                              field: "chequeDate",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        ></CustomDateField>
                                      </Grid>
                                    </React.Fragment>
                                  )}

                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Application Number"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.applicationNum}`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Repay Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.repayAmt === "0"
                                        ? 0
                                        : parseInt(row.repayAmt).toLocaleString(
                                          "en-IN"
                                        )
                                      }`}
                                  </Grid>
                                  {props.screenMode !== "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Amount"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` :  ${
                                          row.chequeAmt === "0"
                                            ? 0
                                            : parseInt(
                                                row.chequeAmt
                                              ).toLocaleString("en-IN")
                                        }`}
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  {props.screenMode === "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Amount"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        <TextField
                                          autoComplete="off"
                                          sx={{
                                            "& .MuiInputBase-input": {
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            },
                                          }}
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            style: {
                                              textAlign: `left`,
                                              fontSize: "12px",
                                            },
                                          }}
                                          type="number"
                                          variant="standard"
                                          value={row.chequeAmt}
                                          placeholder="Please Enter Cheque Amount"
                                          disabled={false}
                                          onChange={(event) => {
                                            let params = {
                                              id: row.id,
                                              field: "chequeAmt",
                                              value: event.target.value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                          onBlur={() => {}}
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === "e" ||
                                              e.key === "E" ||
                                              e.key === "-" ||
                                              e.key === "+"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  {props.screenMode !== "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Status"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` :  ${row.chequeStatus}`}
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                  {props.screenMode === "MODIFY" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Status"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        <span
                                          style={{
                                            display: "flex",
                                          }}
                                        >
                                          {` : `}
                                          <CustomAutoComplete
                                            variant="standard"
                                            type="text"
                                            placeholder="Select Cheque Status"
                                            autoCompleteValues={[
                                              "ENTRY",
                                              "CANCEL",
                                            ]}
                                            value={row.chequeStatus}
                                            onChange={(e, value) => {
                                              let params = {
                                                id: row.id,
                                                field: "chequeStatus",
                                                value: value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        </span>
                                      </Grid>
                                    </React.Fragment>
                                  )}
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Divider />
                      </React.Fragment>
                    ))}
                    {rows.length === 0 && (
                      <NoDataFound
                        message={"No Security PDC Data Found."}
                        imageStyle={{
                          marginTop:
                            accordianOpen && window.innerHeight < 1000
                              ? "20px"
                              : "20%",
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </React.Fragment>
            </Paper>
          )}
        </React.Fragment>
        <AccordianContainer
          id="accord"
          title="Cheque Info"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          {showChequeListGrid && (
            <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
              <Grid container rowSpacing={0} columnSpacing={1}>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    disabled={true}
                    label="Cheque Type"
                    id="chequeType"
                    variant="standard"
                    type="text"
                    placeholder="Select Cheque Type"
                    value={chequeDetailsInfo.chequeType}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    disabled={true}
                    label="MICR Type"
                    id="micrType"
                    variant="standard"
                    value={chequeDetailsInfo.micrType}
                    type="text"
                    placeholder="Enter MICR Type."
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="MICR"
                    label="MICR"
                    variant="standard"
                    disabled={true}
                    required={false}
                    value={chequeDetailsInfo.micrNumber}
                  ></CustomTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    variant="standard"
                    type="text"
                    placeholder="Select Drawee Bank"
                    label="Drawee Bank"
                    disabled={true}
                    value={chequeDetailsInfo.drawerBank}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    variant="standard"
                    type="text"
                    placeholder="Select Drawee Branch"
                    label="Drawee Branch"
                    disabled={true}
                    required={false}
                    value={chequeDetailsInfo.drawerBranch}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="IFSC"
                    variant="standard"
                    disabled={true}
                    value={chequeDetailsInfo.ifsc}
                  ></CustomTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Account Number"
                    variant="standard"
                    disabled={true}
                    value={chequeDetailsInfo.accNumber}
                  ></CustomTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Account Holder Name"
                    variant="standard"
                    disabled={true}
                    value={chequeDetailsInfo.accHolderName}
                  ></CustomTextField>
                </Grid>
              </Grid>
            </Paper>
          )}
        </AccordianContainer>
      </AccordianContainer>
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Dialog
        open={saveInfoDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{saveInfoDialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {saveInfoDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button onClick={handleClose} ref={okRef}>
              {"Ok"}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Dialog
          open={open}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{dialogTitleMessage}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="" placement="top">
              <Button onClick={handleConfirmClose} ref={""}>
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="" placement="top">
              <Button onClick={handleOk} ref={""}>
                Yes
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
    </React.Fragment>
  );
};

export default SecurityChequeList;
